<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

import { formatDateHuman } from '@/api/formatter'

const { records, isSelected } = defineProps<{
  records: any[],
  isSelected: Function,
}>()

const emit = defineEmits(['set', 'getRecords', 'select', 'unselect', 'isSelected'])
</script>

<template>
  <VFragment>
    <VTable v-if="records?.length">
      <thead>
        <tr>
          <th>
            Номер сертификата
          </th>
          <th>
            Срок действия
          </th>
          <th>
            Наименование продукции
          </th>
          <th>
            Производитель
          </th>
          <th>
            Файлы
          </th>
          <th class="text-center">
            Действие
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="record in records"
          :key="record.Uuid"
        >
          <td>{{ record.CertNumber }}</td>
          <td>{{ formatDateHuman(record.ValidTo) }}</td>
          <td>{{ record.ProductName }}</td>
          <td>{{ record.VendorName }}</td>
          <td class="text-center">
            <VIcon
              v-if="record.FileAvailable"
              class="templates-table-body__fileAvailable-icon"
              icon="mdi-check"
            />
            <div v-else>
              —
            </div>
          </td>
          <td class="text-center">
            <WidgetRecordAction
              :selected="isSelected(record.Uuid)"
              @set="emit('select', record)"
              @delete="emit('unselect', record)"
            />
          </td>
        </tr>
      </tbody>
    </VTable>

    <VListItem v-else>
      Нет данных.
    </VListItem>
  </VFragment>
</template>
